<template>
  <div class="mt-auto mb-0">
    <hr/>
    <div class="col-md-13 p-0 mt-2">
      <div class="switch-title">
        Restmateriaal meeleveren
        <font-awesome-icon id="restmaterials-info-icon" class="font-awesome-icon restmaterials-info" icon="info-circle"/>
        <b-tooltip target="restmaterials-info-icon" variant="secondary" placement="top">Onze zaagschema's zijn indicatief, hieraan zijn geen rechten te ontlenen. Indien je één restpaneel met specifieke afmetingen wil, dien je die als paneel in te voeren</b-tooltip>

        <span class="switch float-right">
          <label>
            <input type="checkbox" v-model="restmaterialsChecked" @change="changeRestmaterials($event)" checked>
            <span class="slider round"></span>
          </label>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_RESTMATERIALS } from '../../../store/types'

  export default {
    computed: {
      restmaterialsChecked: {
        get() {
          return this.$store.getters.restMaterials
        },
        set(value) {
          this.$store.dispatch(SET_RESTMATERIALS, value)
        }
      }
    },
    methods: {
      changeRestmaterials(event) {
        if (this.$store.getters.restMaterials !== this.restmaterialsChecked) {
          this.$store.dispatch(SET_RESTMATERIALS, this.restmaterialsChecked)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .switch-title {
    line-height: 26px;
  }
</style>
